import React, { useEffect, useState } from "react";
import CardConfig from "@fcomponents/profile_settings/content/card-config/CardConfig";
import OptionalsList from "@fcomponents/profile_settings/content/optionals-list/OptionalsList";
import { openNotificationWithIcon } from "@utilities/notificationWithIcon";
import { OptionalService } from "@services/optional_service";

// Refacfor de portales: Eliminar este archivo 
const ProfileSettings = ({}) => {
  const [optionals, setOptionals] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  const optionalService = new OptionalService();

  useEffect(() => {
    fetchOptionals();
  }, []);

  const fetchOptionals = () => {
    setIsFetching(true);
    optionalService.fetchAll(
      (data) => {
        setOptionals(data);
        setIsFetching(false);
      },
      (err) => {
        openNotificationWithIcon(
          "error",
          "Ocurrión un error al cargar la información, intenta más tarde.",
          ""
        );
        setIsFetching(false);
      }
    );
  };

  const onSaveData = (itemsToUpdate,e) => {
    e.preventDefault()
    optionalService.availableElements(
      itemsToUpdate,
      (data) => {
        fetchOptionals();
        openNotificationWithIcon(
          "success",
          "Información actualizada correctamente",
          ""
        );
      },
      (error) => {}
    );
  };

  return (
    <div>
      <CardConfig>
        <OptionalsList optionals={optionals} onSaveData={onSaveData} isFetching={isFetching}/>
      </CardConfig>
    </div>
  );
};

export default ProfileSettings;
